module.exports = __webpack_public_path__ + "static/media/nike-never-ask-smolov.74b42660.mp4";